var throttle = require('lodash/throttle');
var BASE_CONFIG = window.BASE_CONFIG;
var mql = window.matchMedia('(max-width: ' + (BASE_CONFIG.responsive.screen__768 - 1) + 'px)');

/**
 * Add Listeners to video controls
 *
 * @param {Object} video Video tag element
 * @param {Object} videoControls Video controls
 */
function setControlListeners(video, videoControls) {
    var playpause = videoControls.find('.pd-video__playpause');

    video.addEventListener('play', function () {
        playpause[0].setAttribute('data-state', 'play');
        video.setAttribute('controls', true);
        videoControls.addClass('is-hidden');
    }, false);

    video.addEventListener('ended', function () {
        playpause[0].setAttribute('data-state', 'pause');
        video.removeAttribute('controls');
        videoControls.removeClass('is-hidden');
    }, false);

    if (playpause) {
        playpause[0].addEventListener('click', function () {
            if (video.readyState < 3) { // Is not loaded.
                video.load();
            }
            if (video.paused || video.ended) video.play();
            else video.pause();
        });
    }
}

/**
 * Set video poster
 *
 * @param {Object} video Video tag element
 */
function setVideoPoster(video) {
    var windowWidth = window.innerWidth;

    if (windowWidth > BASE_CONFIG.responsive.screen__320 && windowWidth < BASE_CONFIG.responsive.screen__375 && video.getAttribute('data-poster_screen__375')) {
        video.setAttribute('poster', video.getAttribute('data-poster_screen__375'));
    } else if (windowWidth >= BASE_CONFIG.responsive.screen__375 && windowWidth < BASE_CONFIG.responsive.screen__480 && video.getAttribute('data-poster_screen__480')) {
        video.setAttribute('poster', video.getAttribute('data-poster_screen__480'));
    } else if (windowWidth >= BASE_CONFIG.responsive.screen__480 && windowWidth < BASE_CONFIG.responsive.screen__768 && video.getAttribute('data-poster_screen__768')) {
        video.setAttribute('poster', video.getAttribute('data-poster_screen__768'));
    } else if (windowWidth >= BASE_CONFIG.responsive.screen__768 && windowWidth < BASE_CONFIG.responsive.screen__900 && video.getAttribute('data-poster_screen__900')) {
        video.setAttribute('poster', video.getAttribute('data-poster_screen__900'));
    } else if (windowWidth >= BASE_CONFIG.responsive.screen__900 && windowWidth < BASE_CONFIG.responsive.screen__1025 && video.getAttribute('data-poster_screen__1025')) {
        video.setAttribute('poster', video.getAttribute('data-poster_screen__1025'));
    } else if (windowWidth >= BASE_CONFIG.responsive.screen__1025 && windowWidth < BASE_CONFIG.responsive.screen__1280 && video.getAttribute('data-poster_screen__1280')) {
        video.setAttribute('poster', video.getAttribute('data-poster_screen__1280'));
    } else if (windowWidth >= BASE_CONFIG.responsive.screen__1280 && windowWidth < BASE_CONFIG.responsive.screen__1440 && video.getAttribute('data-poster_screen__1440')) {
        video.setAttribute('poster', video.getAttribute('data-poster_screen__1440'));
    } else if (windowWidth >= BASE_CONFIG.responsive.screen__1440 && video.getAttribute('data-poster_screen__1920')) {
        video.setAttribute('poster', video.getAttribute('data-poster_screen__1920'));
    } else if (windowWidth >= BASE_CONFIG.responsive.screen__1920 && video.getAttribute('data-poster_screen__2400')) {
        video.setAttribute('poster', video.getAttribute('data-poster_screen__2400'));
    }
}

/**
 * Change video source and play if it was already playing
 *
 * @param {Object} video Video tag element
 */
function changeVideoSource(video) {
    var isOrigVideoPlaying = !!(video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2);
    var source = $(video).find('source');
    var srcMobile = source.data('src-mobile');

    if (srcMobile) {
        if (mql.matches) {
            source.attr('src', srcMobile);
        } else {
            var srcDesktop = source.data('src-desktop');
            source.attr('src', srcDesktop);
        }

        video.load();

        if (isOrigVideoPlaying || video.getAttribute('data-autoplay')) {
            /**
                 * Play video after load and remove loadeddata listener
                 */
            function handleLoad() { // eslint-disable-line no-inner-declarations
                video.play();
                video.removeEventListener('loadeddata', handleLoad);
            }

            video.addEventListener('loadeddata', handleLoad);
        } else {
            var endedEvent = new Event('ended');
            video.dispatchEvent(endedEvent);
        }
    }
}

$(document).ready(function () {
    $('.pd-video').each(function () {
        var videoWrapper = $(this);
        var video = videoWrapper.find('.pd-video__video')[0];
        var videoControls = videoWrapper.find('.pd-video__controls');
        var source = $(video).find('source');
        var srcMobile = source.data('src-mobile');
        const isAutoplay = video.getAttribute('data-autoplay');

        if (mql.matches && srcMobile) {
            source.attr('src', srcMobile);
        }

        if (video.getAttribute('data-is-lcp') === 'true') {
            video.load();
        }

        if (isAutoplay || video.poster) {
            var videoObserver = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.intersectionRatio > 0) {
                        if (isAutoplay) {
                            if (entry.target.readyState < 3) { // Is not loaded.
                                entry.target.load();
                            }
                            entry.target.play();
                        }

                        if (video.poster && (!isAutoplay || (isAutoplay && !video.getAttribute('data-loop')))) {
                            setVideoPoster(video);

                            window.addEventListener(
                                'resize',
                                throttle(function () {
                                    setVideoPoster(video);
                                }, 100),
                                false
                            );
                        }
                        videoObserver.unobserve(entry.target);
                    }
                });
            }, { threshold: 0 });

            videoObserver.observe(video);
        }

        if (videoControls.length > 0) {
            setControlListeners(video, videoControls);
        }
    });

    var changeVideoHandler = () => {
        $('.pd-video__video').each(function () {
            changeVideoSource($(this)[0]);
        });
    };

    if (mql.addListener) {
        mql.addListener(changeVideoHandler);
    } else {
        mql.addEventListener('change', changeVideoHandler);
    }
});
